import { createStyles, rem } from "@mantine/core";

export const useStyles = createStyles(
  (theme, { isOpen }: { isOpen: boolean }) => ({
    wrapper: {
      width: isOpen ? rem(300) : rem(84),
      background: theme.colors.midnightBlue[0],
      padding: rem(20),
      transition: "width 50ms ease",
      zIndex: 1000,
    },
    itemsWrapper: {
      height: "100%",
    },
    divider: {
      borderColor: theme.colors.dusk[0],
    },
    logoutWrapper: {
      textDecoration: "none",
    },
  })
);
